// Magic UI ShimmerButton, MIT: https://magicui.design/r/shimmer-button.json
// JS/Tailwind3 adaptation: pseudo-elements keep decorative layers out of the accessibility tree.
import React from 'react';
import { cn } from '../../lib/utils';

export const ShimmerButton = React.forwardRef(({ className, children, type = 'button', ...props }, ref) => (
  <button ref={ref} type={type} className={cn('magic-shimmer-button', className)} {...props}>
    <span className="magic-shimmer-content">{children}</span>
  </button>
));
ShimmerButton.displayName = 'ShimmerButton';